/**
 * constants
 */

export const DEFAULT_HEIGHT = 722;
export const DEFAULT_WIDTH = 1520;
export const RENDER_SCALE = DEFAULT_HEIGHT / 1444;
export const RESIZE_FACTOR = 1;
export const ASSET_SIZE = "medium";
export const WEBSITE_URL = "https://www.organs-talk.com/";